import { render } from "./usercompany.vue?vue&type=template&id=0d56d854&scoped=true"
import script from "./usercompany.vue?vue&type=script&lang=js"
export * from "./usercompany.vue?vue&type=script&lang=js"

import "./usercompany.vue?vue&type=style&index=0&id=0d56d854&scoped=true&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d56d854"]])

export default __exports__